import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	backButton: {
		id: 'projectLandingSelector.backButton',
		defaultMessage: 'Back',
	},
	continueButton: {
		id: 'projectLandingSelector.continueButton',
		defaultMessage: 'Continue',
	},
	header: {
		id: 'projectLandingSelector.header',
		defaultMessage: 'How would you like to get started?',
	},
	subHeader: {
		id: 'projectLandingSelector.subHeader',
		defaultMessage: 'Your choices won’t limit what you can do in Jira later.',
	},
	exploreSampleProjectHeader: {
		id: 'projectLandingSelector.exploreSampleProject.header',
		defaultMessage: 'Explore a sample project',
	},
	exploreSampleProjectBody: {
		id: 'projectLandingSelector.exploreSampleProject.body',
		defaultMessage: 'Use sample tasks to learn the basics of Jira',
	},
	createProjectHeader: {
		id: 'projectLandingSelector.createProject.header',
		defaultMessage: 'Create your first project',
	},
	createProjectBody: {
		id: 'projectLandingSelector.createProject.body',
		defaultMessage: 'Setup a new project for your team',
	},
});
